/** Rechnungstyp – getrennt vom Zahlungsstatus. */

export type InvoiceType = "deposit" | "final" | "full" | "electricity" | "credit_note";

export const INVOICE_TYPE_LABELS: Record<InvoiceType, string> = {
  deposit: "Anzahlung",
  final: "Schlussrechnung",
  full: "Vollrechnung",
  electricity: "Strom-Nachzahlung",
  credit_note: "Gutschrift",
};

export function invoiceTypeLabel(type: string): string {
  const key = type as InvoiceType;
  return INVOICE_TYPE_LABELS[key] ?? type;
}
